import { Controller } from '@hotwired/stimulus'
import pako from 'pako'

export default class extends Controller<HTMLFormElement> {
  compress (): void {
    const form = this.element

    const selectedScInputs = Array.from(form.querySelectorAll<HTMLInputElement>('input[name="sc[]"]'))
    const scValues = selectedScInputs
      .filter(input => input.type === 'checkbox' ? input.checked : true)
      .map(input => input.value)

    const cValues = Array.from(form.querySelectorAll<HTMLInputElement>('input[name="c[]"]'))
      .map(input => input.value)

    const payload = JSON.stringify({ sc: scValues, c: cValues })

    const deflated = pako.deflate(payload)
    let binary = ''
    deflated.forEach(b => { binary += String.fromCharCode(b) })
    const base64 = btoa(binary)

    this.setOrUpdateHidden('sc_x', base64)

    const toDisable = Array.from(form.querySelectorAll<HTMLInputElement>('input[name="sc[]"], input[name="c[]"], input[name="page"]'))
    toDisable.forEach(input => { input.disabled = true })

    setTimeout(() => {
      toDisable.forEach(input => { input.disabled = false })
    }, 0)
  }

  private setOrUpdateHidden (name: string, value: string): void {
    let input = this.element.querySelector<HTMLInputElement>(`input[name="${name}"]`)
    if (input == null) {
      input = document.createElement('input')
      input.type = 'hidden'
      input.name = name
      this.element.appendChild(input)
    }
    input.value = value
  }
}
